















































































































































import {
  EventStatus,
  EMEventType,
  OptimizeGoal,
  AdgroupFormData,
  IOS14QuotaType,
  CampaignFormData,
} from '@tt4b/ttam-enums';
import { defineComponent, computed, toRefs, PropType } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import ALink from '@/components/common/a-link/a-link.vue';
import { useAllowlist, useStdAdgroupIs, useStdObjectiveType } from '@tt4b/ttam-hooks';

const name = 'ttam-app-event-external-action-select';
export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    value: {
      type: [Number, String],
      required: true,
    },
    isExternalAction: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    appId4EM: {
      type: String,
      default: '',
    },
    aadvid: {
      type: String,
      default: '',
    },
    isCboAeo: {
      type: Boolean,
      default: false,
    },
    isHasTTPWhite: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { appId4EM, aadvid, isCboAeo, adgroupData, campaignData } = toRefs(props);

    const isCBOAEODisable = item => props.isExternalAction && isCboAeo.value && !item.is_no_bid_enabled;
    const { isProductSales } = useStdObjectiveType({ campaignFormData: campaignData });
    const isSupportIos14 = computed(() => adgroupData.value.ios14QuotaType === IOS14QuotaType.OCCUPIED);
    const { isAeoDcCostCapWhite } = useAllowlist();
    const { isHasTikTok } = useStdAdgroupIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    // dsa * dc * aeo场景下，cost cap依赖白名单，lowest cost依赖is_no_bid_enabled
    // 有可能出现出价不能选的情况，这种情况需要禁选event
    const isDCAEODisable = item => {
      const isOptTargetInAppEvent = adgroupData.value.optimizeGoal === OptimizeGoal.IN_APP_EVENT;
      return (
        props.isExternalAction &&
        isProductSales.value &&
        isSupportIos14.value &&
        isOptTargetInAppEvent &&
        !item.is_no_bid_enabled &&
        !(isAeoDcCostCapWhite.value && isHasTikTok.value)
      );
    };
    const computedRatio = item => {
      if (!item.unlock_threshold) {
        return 0;
      }

      return item.conversion_cnt > item.unlock_threshold
        ? 100
        : Math.round((item.conversion_cnt / item.unlock_threshold) * 100);
    };

    const statusText = item => {
      if (item.aeo_availability === EventStatus.INSUFFICIENT) {
        return i18n.t('module_status_insufficient');
      } else if (item.aeo_availability === EventStatus.INACTIVE) {
        return i18n.t('module_status_unactive');
      } else {
        return i18n.t('module_status_active');
      }
    };

    const optionEnable = item =>
      (item.is_beta || item.aeo_availability === EventStatus.READY) && !isCBOAEODisable(item) && !isDCAEODisable(item);

    const optionClass = item => {
      const isSelected = item.external_action === props.value;

      return {
        [`${name}__item`]: true,
        [`${name}__item--selected`]: isSelected,
        [`${name}__item--active`]:
          item.aeo_availability === EventStatus.READY && !isCBOAEODisable(item) && !isDCAEODisable(item),
        [`${name}__item--insufficient`]: item.aeo_availability === EventStatus.INSUFFICIENT,
        [`${name}__item--not-active`]:
          item.aeo_availability === EventStatus.INACTIVE || isCBOAEODisable(item) || isDCAEODisable(item),
      };
    };

    const insufficientTooltipHint = item => {
      const ratio = computedRatio(item);

      if (props.isExternalAction) {
        return ratio === 100
          ? i18n.t('module_aeo_external_action_info', { ratio })
          : i18n.t('module_aeo_external_action_merge_info', { ratio });
      }

      return ratio === 100
        ? i18n.t('module_adgroup_deep_external_action_info', { ratio })
        : i18n.t('module_adgroup_deep_external_action_merge_info', { ratio });
    };

    const appDetailLink = computed(
      () => `${window.location.origin}/i18n/events_manager/app/detail/${appId4EM.value}?aadvid=${aadvid.value}`,
    );

    const handleSelectChange = val => {
      emit('change', val);
      emit('input', val);
    };

    // disabled态 & 不存在 list中，拼接starling key
    const finalValue = computed(() => {
      const isExistCurrentValue = (props.options as Array<any>).find(item => item.external_action === props.value);
      return props.disabled && !isExistCurrentValue && props.value
        ? i18n.t(`app_rpc.external_action.${props.value}`)
        : props.value;
    });

    return {
      name,
      statusText,
      optionEnable,
      optionClass,
      EventStatus,
      EMEventType,
      computedRatio,
      appDetailLink,
      isDCAEODisable,
      insufficientTooltipHint,
      handleSelectChange,
      isCBOAEODisable,
      finalValue,
    };
  },
});
